import React,{useState,useEffect,useCallback} from "react";
import {Link} from 'react-router-dom'
import _ from 'lodash'
import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable'
import * as XLSX from 'xlsx/xlsx.mjs';
import $ from 'jquery';
import html2PDF from 'jspdf-html2canvas';
import html2canvas from 'html2canvas';


const TcReportmain = () => {

  const pageSize = 5;
  const[report,setReport] = useState([])

  const [allusers,setAllusers]= useState([])  
   // const [currentPage, setcurrentPage] = useState(1);
    const [details,setDetails]= useState([])  
  
  useEffect(()=>{
    Get()
    GetAdminReport();
    document.getElementById('Reporttable').style.display = "none";
    document.getElementById('Tc-Reportbtn').style.display = "none";
    document.getElementById('pagination').style.display = "none";
    document.getElementById('HideReportTable').style.display = "none";
  },[])

  function displaytable(){
    // e.preventDefault();
    document.getElementById('Reporttable').style.display = "flex";
    document.getElementById('form').style.display = "none";
     document.getElementById('Tc-Reportbtn').style.display = "flex";
     document.getElementById('pagination').style.display = "block";
  
   
  }

  function handlechange(){
    var name = document.getElementById('user').value;
    var password = document.getElementById('password').value;
      
    if(!name){
      document.getElementById("nameerror").innerHTML = "Name Required";
    }
    else{
      document.getElementById("nameerror").innerHTML = "";
    }
     if(!password){
      document.getElementById("pswerror").innerHTML = "Password Required";
    }
    else{
    document.getElementById("pswerror").innerHTML = "";
  }
  }

  function Tcreporthide(){

    var x = document.getElementById("password");
  
    var eye = document.getElementById("eye-loginform");
  
    if(x.type === "password"){
   x.type = "text";
      eye.classList.remove("fa-eye-slash")
      eye.classList.add("fa-eye")
     
   }
    else{
      x.type = "password";
      eye.classList.remove("fa-eye")
      eye.classList.add("fa-eye-slash")
  
    }
   }
   
   function GetAdminReport(){
     
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

    fetch('https://tclapi.thatscool.in/api/Report/AdminReport', {
     
    method:'GET',
   
      headers : {
  
        "Content-type": "application/json",
        "Accept": "application/json",
        //"Access-Control-Allow-Headers": "Access-Control-Request-Headers ",
        "Access-Control-Allow-Origin": "*",
        'Authorization':bearer 
      },
  
    
  }).then(response => response.json())
  .then(data => {
  console.log("Data",data)
  setAllusers(data)
  setReport(_(data).slice(0).take(pageSize).value())

  localStorage.setItem("TcReportData", JSON.stringify(data));

  });

  }

  function Get(){
     
    fetch('https://localhost:44312/Api/Tc/GetTcsection', {
     
    method:'GET',
    // withCredentials: true,    
    // crossorigin: true,    
    // mode: 'cors',
      headers : {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        //"Authorization": bearer,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
  
 //body:JSON.stringify(data)

}).then(response => response.json())
.then(data => {
console.log("Data",data)
  setDetails(data)
   
});

}
/*----Pagination----*/

  // const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
 
  // const pages = _.range(1, pageCount+1)
  
  // const pagination =(pageNo)=>{
  // setcurrentPage(pageNo);
  // const startIndex = (pageNo - 1) * pageSize;
  // const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
  // setReport(paginatedPost)
  // }


  

  function login(e){

     e.preventDefault();
  
  var name = document.getElementById('user').value;
  var password = document.getElementById('password').value;
    
  if(!name){
    document.getElementById("nameerror").innerHTML = "Name Required";
  }
  else{
    document.getElementById("nameerror").innerHTML = "";
  }
   if(!password){
    document.getElementById("pswerror").innerHTML = "Password Required";
  }
  else{
  document.getElementById("pswerror").innerHTML = "";
  
  
      let body={
        username:document.getElementById('user').value,
        password:document.getElementById('password').value,
        OSX_Platform:"A",
        Version:"1.0.71",
      Device_Id:"NoTokenForAdmin",
    };
       console.log(body)

let username = document.getElementById('user').value
       
    if(username!=="6381061700"){
document.getElementById('nameerror-notify').style.display = "block"
          setTimeout(()=>{
            document.getElementById('nameerror-notify').style.display = "none"
          },1000)
}   
else if(password!=="Dhinesh@123"){
document.getElementById('pswerror-notify').style.display = "block"
          // setTimeout(()=>{
          //   document.getElementById('pswerror-notify').style.display = "none"
          // },1000)
}
    else{ 
      
     document.getElementById('success-notify').style.display = "block"
          setTimeout(()=>{
          document.getElementById('success-notify').style.display = "none"
        },1000)
      
       axios({
        method: "POST",
      
        url:'https://tclapi.thatscool.in/api/Authenticate/login',
        data:body,
        headers: {
          "Content-Type": "application/json"
        }
      })   
        .then((response) =>{
        console.log(response.data);
        // setpop(true);
        // setTimeout(()=>{
        //   setpop(false);
        //buttondisplay()
        // },1000)
     
        displaytable()  
        })   
        .catch(error => {
          console.log(error);
          document.getElementById('error-notify').style.display = "block"
          setTimeout(()=>{
            document.getElementById('error-notify').style.display = "none"
          },1000)
         document.getElementById('user').value=""
      document.getElementById('password').value=""
        })
   
        }
        
      }
      
  }
    /*---  pdf download btn---*/

 function downloadreportpdf(){


  // var doc = new jsPDF();
   //var image = "https://images.unsplash.com/photo-1591871937573-74dbba515c4c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8NXx8fGVufDB8fHx8&w=1000&q=80";
  //var image = document.getElementById('picture').innerHTML;
  //   //console.log(image)
  
  //  doc.addImage(image, 'JPEG', 15, 40, 50, 50)
  //  doc.save('ReportTable.pdf');
   


  var pdf = new jsPDF();
  
  pdf.autoTable({html:'#HideReportTable'});
 
  pdf.save('ReportTable.pdf'); 
 
  
//   const input = document.getElementById('TcReportTable');
//   html2canvas(input,{logging:true, letterRendering:1,useCORS:true})
//     .then((canvas) => {
//       const imgWidth = 208;
// const imgHeight = canvas.height * imgWidth / canvas.width;
//     const imgData = canvas.toDataURL('image/jpeg',1.0);
//     const pdf = new jsPDF('p','mm','a4');
//     pdf.addImage(imgData,'JPEG',0,0,imgWidth,imgHeight);
//     pdf.save('ReportTable.pdf');
//     })
    
  

 }
 


 /*---  excel download btn---*/



 function downloadreportExcel(){

   var table = document.getElementById("HideReportTable"); 
   //console.log(table)
  
   var workbook = XLSX.utils.table_to_book(table)
    
   XLSX.writeFile(workbook, "ReportTable.xlsx");  
 
   console.log(workbook); 

  }


  function exportExcel(){ //<table> id and filename
    var today = new Date();
    var date = ('0'+today.getDate()).slice(-2)+"-"+('0'+(today.getMonth()+1)).slice(-2)+"-"+today.getFullYear();

    var file_name = 'ReporTcsectionTabletTable'+"_"+date+".xls"; //filename with current date, change if needed
    var meta = '<meta http-equiv="content-type" content="text/html; charset=UTF-8" />';
    var html = $("#TcsectionTable").clone();

    // html.find('.remove').remove(); //add the 'remove' class on elements you do not want to show in the excel
    // html.find('a').each(function() { //remove links, leave text only
    //     var txt = $(this).text();
    //     $(this).after(txt).remove();
    // });
    // html.find('input, textarea').each(function() { //replace inputs for their respectives texts
    //     var txt = $(this).val().replace(/\r\n|\r|\n/g,"");
    //     $(this).after(txt).remove();
    // });
    // html.find('select').each(function() { //replace selects for their selected option text
    //     var txt = $(this).find('option:selected').text();
    //     $(this).after(txt).remove();
    // });
    html.find('br').attr('style', "mso-data-placement:same-cell"); //make line breaks show in single cell
    html = "<table>"+html.html()+"</table>";

    var uri = 'data:application/vnd.ms-excel,'+encodeURIComponent(meta+html);
    var a = $("<a>", {href: uri, download: file_name});
    $(a)[0].click();

    
}
 
const LEFT_PAGE = "LEFT";
const RIGHT_PAGE = "RIGHT";
const range = (from, to, step = 1) => {
  let i = from;
  const range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }

  return range;
};

const [currentPage, setCurrentPage] = useState(1);

let data = localStorage.getItem("TcReportData")
let transdata =  JSON.parse(data);
let NUM_OF_RECORDS = transdata.length;
let LIMIT = 5;

const onPageChanged = useCallback(

  (event, page) => {
    event.preventDefault();
    setCurrentPage(page);
  },
  [setCurrentPage]
  
);


const currentData = transdata.slice(
  (currentPage - 1) * LIMIT,
  (currentPage - 1) * LIMIT + LIMIT
);

const Paginations = (props) => {
  const {
    totalRecords,
    pageLimit,
    pageNeighbours,
    onPageChanged,
    currentPage
  } = props;
  const [totalPages, setTotalPages] = useState(0);
  useEffect(() => {
    setTotalPages(Math.ceil(totalRecords / pageLimit));
  }, [setTotalPages]);

  const fetchPageNumbers = () => {
    const totalNumbers = pageNeighbours * 2 + 3;
    console.log(totalNumbers)
    console.log(pageNeighbours)
    const totalBlocks = totalNumbers + 2;
    console.log(totalBlocks)

    if (totalPages > totalBlocks) {
      const startPage = Math.max(2, currentPage - pageNeighbours);
      const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);

      let pages = range(startPage, endPage);

      const hasLeftSpill = startPage > 2;
      const hasRightSpill = totalPages - endPage > 1;
      const spillOffset = totalNumbers - (pages.length + 1);

      switch (true) {
        case hasLeftSpill && !hasRightSpill: {
          const extraPages = range(startPage - spillOffset, startPage - 1);
          pages = [LEFT_PAGE, ...extraPages, ...pages];
          break;
        }
        case hasLeftSpill && hasRightSpill:
        default: {
          pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
          break;
        }
      }
      return [1, ...pages, totalPages];
    }
    return range(1, totalPages);
  };


  const pages = fetchPageNumbers() || [];
  return (
    <nav aria-label="Countries Pagination">
      <ul className="pagination">
        {pages.map((page, index) => {
          if (page === LEFT_PAGE)
            return (
              <li key={index} className="page-item">
                <a
                  href="/"
                  className="page-link"
                  aria-label="Previous"
                  onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                >
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
            );

          if (page === RIGHT_PAGE)
            return (
              <li key={index} className="page-item">
                <a
                  className="page-link"
                  href="/"
                  aria-label="Next"
                  onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 3)}
                >
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            );

          return (
            <li
              key={index}
              className={`Tc-page-item${currentPage === page ? " active" : ""}`}
            >
              <a
                className="page-link"
                href="/"
                onClick={(e) => onPageChanged(e, page)}
              >
                {page}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}; 
return(
    <>
 
        <div className='TC-addmain'>   
    <div className="TC-addgrid-layout">
  <div className="TC-addmain-top">
  <div className='TC-addmain-back'>
    <Link to='/Tcsection'><i className="fa-sharp fa-solid fa-backward"></i></Link>
    </div> 
    <span> Report </span>
    </div>
    </div>
    <div class="wrapper fadeInDown" id="form">      
  <div id="transactionform">
      <form className='TransactionForm'>
 <input type="text" id="user"  name="name"  placeholder="UserName" onKeyUp={handlechange}></input>
 <span id="nameerror" className="Transaction-error"></span>
 
  <input type="password" id="password" name="psw"   placeholder="Password" onKeyUp={handlechange}></input>
  <span id="pswerror" className="Transaction-error"></span>
  <i class="fa fa-eye-slash" aria-hidden="true" onClick={Tcreporthide} id="eye-loginform"></i>

<div className='btn-div'>
  <button type='submit' className="fadeIn fourth" onClick={login}>Submit </button>     
  </div>

</form>

    </div>
    </div> 

 {/* --- Report table--- */}

    <div className='TCtable' id='Reporttable'>
     <div class=" TC-ReportTable">
   
     {
  !report ? (""):( 
       <table  className='TC-tblhead' id='TcReportTable'> 
    <thead>
   <tr>
<th>upload_id </th>
<th>Name</th>
 <th>file_name</th>
<th>upload_title</th>
<th>PostOwner</th>
<th>ReportedTime</th>

</tr>
</thead>
<tbody>
{currentData.map((e)=>
{
return<tr>

  <td>{e.upload_id}</td>

<td>{e.ReportedByName}</td>

 <td id="picture"><img id="picture" src={e.file_name}></img></td> 

<td>{e.upload_title}</td>

<td>{e.PostOwner}</td>

<td>{e.ReportedTime.slice(0,10)}</td>


</tr>
 })} 
</tbody>

</table>
 )}



     </div>
    
  </div>

  <br></br>
 <div id="pagination">

 {transdata.length<=5?null:<nav id="Tc-Pag">
    <ul className='Tc-pagination'>

    <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={3}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          />
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='page-link'
            onClick={()=>pagination(page)}  >
          
            {page}
            </p>
            </li>
        ))
      } */}
       
    </ul>
  </nav> }
  </div>

  


  <div className='Tc-TransactionMain' id='Tc-Reportbtn'>
  <button  id='TCdownloadbtn' onClick={downloadreportpdf}>Download as PDF</button>  &nbsp; &nbsp;&nbsp; &nbsp;
     <button id='TCdownloadbtn' onClick={downloadreportExcel} >Download as Excel</button> 
     </div>

     <div>
     <div>
    
       <table  id='HideReportTable'> 
    <thead>
   <tr>
<th>upload_id </th>
<th>Name</th>
 <th>file_name</th>
<th>upload_title</th>
<th>PostOwner</th>
<th>ReportedTime</th>

</tr>
</thead>
<tbody>
{report.map((e)=>
{
return<tr>
  <td>{e.upload_id}</td>
<td>{e.ReportedByName}</td>
<td>{e.file_name.slice(67)}</td>
<td>{e.upload_title}</td>
<td>{e.PostOwner}</td>
<td>{e.ReportedTime.slice(0,10)}</td>
</tr>
 })} 
</tbody>

</table>
     </div> 


     <div className='TCpopfade' id='error-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p> </p>
      <h6 class="notif-title">Unauthorized User</h6> 
   </section>
    </div>
  </div>
</div>

<div className='TCpopfade' id='nameerror-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p> </p>
      <h6 class="notif-title"> Incorrect Username</h6>
   </section>
    </div>
  </div>
</div>


<div className='TCpopfade' id='pswerror-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p> </p>
      <h6 class="notif-title">Incorrect Password</h6> 
   </section>
    </div>
  </div>
</div>

<div className='TCpopfade' id='success-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p></p>
             <h6 class="notif-title"> Login Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          </section> 
            
          
    </div>
  </div>
</div>

  </div> 
    </div>

    </>
)
}

export default TcReportmain;